import { render, staticRenderFns } from "./ModalMakePayment.vue?vue&type=template&id=0fb66e2b&scoped=true&"
import script from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
export * from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMakePayment.vue?vue&type=style&index=0&id=0fb66e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb66e2b",
  null
  
)

export default component.exports